import React from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import './LegalPage.css';

const TermsPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="legal-page">
            <div className="legal-container">
                <header className="legal-header">
                    <h1>{t('terms.title')}</h1>
                    <p className="legal-subtitle">{t('terms.subtitle')}</p>
                    <p className="legal-date">{t('terms.lastUpdated')}: 10.01.2025</p>
                </header>

                <section className="legal-section">
                    <h2>1. {t('terms.sections.provider.title')}</h2>
                    <address className="legal-address">
                        Hofsync GbR i. Gr.<br />
                        Altenberger Gasse 9<br />
                        53639 Königswinter<br />
                        Deutschland
                    </address>
                    <p>E-Mail: <a href="mailto:info@hofsync.com">info@hofsync.com</a></p>
                </section>

                <section className="legal-section">
                    <h2>2. {t('terms.sections.scope.title')}</h2>
                    <p>{t('terms.sections.scope.intro')}</p>
                    <p>{t('terms.sections.scope.businessOnly')}</p>
                    <p>{t('terms.sections.scope.noDeviations')}</p>
                </section>

                <section className="legal-section">
                    <h2>3. {t('terms.sections.services.title')}</h2>
                    <p>{t('terms.sections.services.intro')}</p>
                    <p>{t('terms.sections.services.features')}</p>
                    <p className="legal-highlight">{t('terms.sections.services.noAdvice')}</p>
                </section>

                <section className="legal-section">
                    <h2>4. {t('terms.sections.gdprRole.title')}</h2>
                    <p>{t('terms.sections.gdprRole.userResponsible')}</p>
                    <p>{t('terms.sections.gdprRole.processor')}</p>
                    <p>{t('terms.sections.gdprRole.ownPurposes')}</p>
                </section>

                <section className="legal-section">
                    <h2>5. {t('terms.sections.registration.title')}</h2>
                    <p>{t('terms.sections.registration.required')}</p>
                    <p>{t('terms.sections.registration.obligations')}</p>
                </section>

                <section className="legal-section">
                    <h2>6. {t('terms.sections.userObligations.title')}</h2>
                    <p>{t('terms.sections.userObligations.ensures')}</p>
                    <p>{t('terms.sections.userObligations.responsibility')}</p>
                </section>

                <section className="legal-section">
                    <h2>7. {t('terms.sections.aiSystems.title')}</h2>
                    <p>{t('terms.sections.aiSystems.intro')}</p>
                    <p>{t('terms.sections.aiSystems.results')}</p>
                    <p>{t('terms.sections.aiSystems.noTraining')}</p>
                </section>

                <section className="legal-section">
                    <h2>8. {t('terms.sections.availability.title')}</h2>
                    <p>{t('terms.sections.availability.effort')}</p>
                    <p>{t('terms.sections.availability.maintenance')}</p>
                </section>

                <section className="legal-section">
                    <h2>9. {t('terms.sections.liability.title')}</h2>
                    <p>{t('terms.sections.liability.limitation')}</p>
                </section>

                <section className="legal-section">
                    <h2>10. {t('terms.sections.duration.title')}</h2>
                    <p>{t('terms.sections.duration.terms')}</p>
                </section>

                <section className="legal-section">
                    <h2>11. {t('terms.sections.dataReturn.title')}</h2>
                    <p>{t('terms.sections.dataReturn.export')}</p>
                    <p>{t('terms.sections.dataReturn.deletion')}</p>
                </section>

                <section className="legal-section">
                    <h2>12. {t('terms.sections.final.title')}</h2>
                    <p>{t('terms.sections.final.law')}</p>
                    <p>{t('terms.sections.final.jurisdiction')}</p>
                </section>

                <div className="legal-back">
                    <Link to="/" className="legal-back-link">
                        {t('terms.backToHome')}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default TermsPage;
